// Lesson 1: Aktivitas Pagi Hari - Vocabulary Data
export interface Word {
    id: number;
    batak: string;
    latin: string[];
    indonesia: string;
    syllable_mapping: Array<{
        batak_char: string;
        latin: string;
    }>;
}

// Vocabulary for Lesson 1: Morning Activities
export const unit5Lesson1VocabularyBank: Word[] = [
    {
        id: 501,
        batak: "ᯔᯰᯎᯝᯃ᯲",
        latin: ["ma", "nga", "lak"],
        indonesia: "Bangun",
        syllable_mapping: [
            { batak_char: "ᯔᯰ", latin: "ma" },
            { batak_char: "ᯎ", latin: "nga" },
            { batak_char: "ᯝᯃ᯲", latin: "lak" }
        ]
    },
    {
        id: 502,
        batak: "ᯔᯉᯪᯎᯬᯘ",
        latin: ["ma", "ni", "gos"],
        indonesia: "Mandi",
        syllable_mapping: [
            { batak_char: "ᯔ", latin: "ma" },
            { batak_char: "ᯉᯪ", latin: "ni" },
            { batak_char: "ᯎᯬᯘ", latin: "gos" }
        ]
    },
    {
        id: 503,
        batak: "ᯔᯔᯰᯎᯀᯉ᯲ ᯇᯀᯒᯎᯬᯞᯮ",
        latin: ["ma", "ma", "ngan", "par", "ngo", "lu"],
        indonesia: "Sarapan",
        syllable_mapping: [
            { batak_char: "ᯔᯔᯰ", latin: "ma" },
            { batak_char: "ᯎᯀᯉ᯲", latin: "ngan" },
            { batak_char: "ᯇᯀᯒ", latin: "par" },
            { batak_char: "ᯎᯬ", latin: "ngo" },
            { batak_char: "ᯞᯮ", latin: "lu" }
        ]
    },
    {
        id: 504,
        batak: "ᯔᯉᯔ᯲ᯇᯮᯉ",
        latin: ["ma", "nam", "pu", "na"],
        indonesia: "Berdoa",
        syllable_mapping: [
            { batak_char: "ᯔ", latin: "ma" },
            { batak_char: "ᯉᯔ᯲", latin: "nam" },
            { batak_char: "ᯇᯮ", latin: "pu" },
            { batak_char: "ᯉ", latin: "na" }
        ]
    },
    {
        id: 505,
        batak: "ᯔᯉᯬᯎᯬᯘ",
        latin: ["ma", "no", "gos"],
        indonesia: "Siap-siap",
        syllable_mapping: [
            { batak_char: "ᯔ", latin: "ma" },
            { batak_char: "ᯉᯬ", latin: "no" },
            { batak_char: "ᯎᯬᯘ", latin: "gos" }
        ]
    },
    // Time and additional words
    {
        id: 506,
        batak: "ᯐᯔ᯲",
        latin: ["jam"],
        indonesia: "jam",
        syllable_mapping: [
            { batak_char: "ᯐᯔ᯲", latin: "jam" }
        ]
    },
    {
        id: 507,
        batak: "ᯘᯮᯑᯫ",
        latin: ["su", "de"],
        indonesia: "sudah",
        syllable_mapping: [
            { batak_char: "ᯘᯮ", latin: "su" },
            { batak_char: "ᯑᯫ", latin: "de" }
        ]
    },
    // Numbers for time
    {
        id: 508,
        batak: "ᯀᯬᯉᯬᯔ",
        latin: ["o", "nom"],
        indonesia: "enam",
        syllable_mapping: [
            { batak_char: "ᯀᯬ", latin: "o" },
            { batak_char: "ᯉᯬᯔ", latin: "nom" }
        ]
    },
    {
        id: 509,
        batak: "ᯇᯀᯒᯎᯬᯞᯮ",
        latin: ["par", "ngo", "lu"],
        indonesia: "pagi",
        syllable_mapping: [
            { batak_char: "ᯇᯀᯒ", latin: "par" },
            { batak_char: "ᯎᯬ", latin: "ngo" },
            { batak_char: "ᯞᯮ", latin: "lu" }
        ]
    },
    // Additional vocabulary from previous lessons for context
    {
        id: 105,
        batak: "ᯀᯮ",
        latin: ["au"],
        indonesia: "Saya",
        syllable_mapping: [
            { batak_char: "ᯀᯮ", latin: "au" }
        ]
    },
    {
        id: 107,
        batak: "ᯤᯀ",
        latin: ["i", "a"],
        indonesia: "Dia",
        syllable_mapping: [
            { batak_char: "ᯤ", latin: "i" },
            { batak_char: "ᯀ", latin: "a" }
        ]
    },
	{
		id: 999,
		batak: "",
		latin: ["."],
		indonesia: "",
		syllable_mapping: [{ batak_char: "", latin: "-" }],
	},
];

// Extended word bank for various question types
export const unit5Lesson1ExtendedWordBank: Word[] = [
    ...unit5Lesson1VocabularyBank,
    {
		id: 999,
		batak: "",
		latin: ["."],
		indonesia: "",
		syllable_mapping: [{ batak_char: ".", latin: "-" }],
	},
    {
        id: 200,
        batak: "?",
        latin: ["?"],
        indonesia: "?",
        syllable_mapping: [{ batak_char: "?", latin: "?" }],
    },
{
		id: 999,
		batak: "",
		latin: ["."],
		indonesia: "",
		syllable_mapping: [{ batak_char: "", latin: "-" }],
	},  
];

// Helper function to create word dictionary
export const createUnit5Lesson1WordDict = (wordBank: Word[]) => {
    return Object.fromEntries(wordBank.map((w) => [w.id, w]));
};
